/* =========================================================================
   Foxhills custom engraving configurator + LIVE preview (Phase 1).
   Replaces the HulkApps engraving UI on engrave-template products with a
   clear, validated flow and a live visualisation of the text on the item.
   Phase 2 will wire the £10 charge + the generated preview image.
   Config: window.FoxEngrave (snippets/fox-engrave.liquid).
   ========================================================================= */
(function () {
  'use strict';
  var CFG = window.FoxEngrave;
  if (!CFG || !CFG.enabled || !CFG.product) return;

  var P = CFG.product;
  var state = { engrave: false, type: null, font: null, fontLabel: null, front: '', back: '', side: 'front', confirmed: false };
  var els = {};

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  /* ---------- build UI ---------- */

  function buildUI() {
    var wrap = el('div', 'fox-eng');
    wrap.innerHTML =
      '<div class="fox-eng__bar">' +
        '<span class="fox-eng__label">Personalise with engraving <em>+£10</em></span>' +
        '<div class="fox-eng__yn">' +
          '<button type="button" class="fox-eng__yn-btn is-on" data-eng="no">No</button>' +
          '<button type="button" class="fox-eng__yn-btn" data-eng="yes">Yes</button>' +
        '</div>' +
      '</div>' +
      '<div class="fox-eng__panel" hidden>' +
        '<div class="fox-eng__preview">' +
          '<img class="fox-eng__img" alt="Engraving preview">' +
          '<div class="fox-eng__text"></div>' +
        '</div>' +
        '<div class="fox-eng__side">' +
          '<button type="button" class="fox-eng__side-btn is-on" data-side="front">Front</button>' +
          '<button type="button" class="fox-eng__side-btn" data-side="back">Back</button>' +
        '</div>' +
        '<div class="fox-eng__group"><div class="fox-eng__h">Engraving type</div><div class="fox-eng__types"></div></div>' +
        '<div class="fox-eng__group fox-eng__fonts-group" hidden><div class="fox-eng__h">Font</div><div class="fox-eng__fonts"></div></div>' +
        '<div class="fox-eng__group"><div class="fox-eng__h">Front text</div>' +
          '<input type="text" class="fox-eng__front" maxlength="30" placeholder="Up to 30 characters"></div>' +
        '<div class="fox-eng__group"><div class="fox-eng__h">Back text <span class="fox-eng__opt">optional</span></div>' +
          '<input type="text" class="fox-eng__back" maxlength="30" placeholder="Up to 30 characters"></div>' +
        '<label class="fox-eng__confirm"><input type="checkbox" class="fox-eng__confirm-cb"> I confirm the engraving details are correct</label>' +
        '<p class="fox-eng__note">Please check your spelling carefully. All engraving is centred on the item and produced exactly as entered. Engraved items cannot be returned or exchanged, and orders can take up to 7 business days for delivery.</p>' +
        '<div class="fox-eng__err" hidden></div>' +
      '</div>';
    return wrap;
  }

  function renderTypes() {
    els.types.innerHTML = '';
    CFG.types.forEach(function (t) {
      var b = el('button', 'fox-eng__chip', t.name);
      b.type = 'button';
      b.setAttribute('data-type', t.name);
      if (state.type === t.name) b.classList.add('is-on');
      els.types.appendChild(b);
    });
  }

  function renderFonts() {
    els.fonts.innerHTML = '';
    var t = CFG.types.filter(function (x) { return x.name === state.type; })[0];
    if (!t) { els.fontsGroup.hidden = true; return; }
    els.fontsGroup.hidden = false;
    t.fonts.forEach(function (f) {
      var b = el('button', 'fox-eng__chip fox-eng__font-chip', f.label);
      b.type = 'button';
      b.style.fontFamily = f.css;
      b.setAttribute('data-font', f.css);
      b.setAttribute('data-font-label', f.label);
      if (state.fontLabel === f.label) b.classList.add('is-on');
      els.fonts.appendChild(b);
    });
  }

  /* ---------- live preview ---------- */

  function updatePreview() {
    var t = els.text, box = els.preview;
    if (!t || !box) return;
    // swap to the clean front/back disc image for this side when faces are configured
    if (CFG.faces && els.img) {
      var face = CFG.faces[state.side] || CFG.faces.front;
      if (face && els.img.getAttribute('src') !== face) els.img.src = face;
    }
    var txt = state.side === 'back' ? state.back : state.front;
    t.textContent = txt || '';
    t.style.fontFamily = state.font || "'Jost', sans-serif";
    var w = box.clientWidth || 320;
    t.style.left = CFG.area.cx + '%';
    t.style.top = CFG.area.cy + '%';
    t.style.maxWidth = CFG.area.width + '%';
    t.style.fontSize = Math.max(10, (CFG.area.size / 100) * w) + 'px';
  }

  /* ---------- wiring ---------- */

  function setEngrave(on) {
    state.engrave = on;
    els.panel.hidden = !on;
    els.wrap.querySelectorAll('[data-eng]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-eng') === (on ? 'yes' : 'no')); });
    if (on) updatePreview();
  }

  function bind() {
    els.wrap.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t.closest('[data-eng]')) { setEngrave(t.closest('[data-eng]').getAttribute('data-eng') === 'yes'); return; }
      var typeBtn = t.closest('[data-type]');
      if (typeBtn) {
        state.type = typeBtn.getAttribute('data-type');
        state.font = null; state.fontLabel = null;
        renderTypes(); renderFonts(); clearErr();
        return;
      }
      var fontBtn = t.closest('[data-font]');
      if (fontBtn) {
        state.font = fontBtn.getAttribute('data-font');
        state.fontLabel = fontBtn.getAttribute('data-font-label');
        els.fonts.querySelectorAll('.fox-eng__chip').forEach(function (c) { c.classList.toggle('is-on', c === fontBtn); });
        updatePreview(); clearErr();
        return;
      }
      var sideBtn = t.closest('[data-side]');
      if (sideBtn) {
        state.side = sideBtn.getAttribute('data-side');
        els.wrap.querySelectorAll('[data-side]').forEach(function (b) { b.classList.toggle('is-on', b === sideBtn); });
        updatePreview();
        return;
      }
    });
    els.front.addEventListener('input', function () { state.front = els.front.value.trim(); if (state.side !== 'back') updatePreview(); clearErr(); });
    els.back.addEventListener('input', function () { state.back = els.back.value.trim(); if (state.side === 'back') updatePreview(); });
    els.confirm.addEventListener('change', function () { state.confirmed = els.confirm.checked; clearErr(); });
    window.addEventListener('resize', updatePreview);
  }

  function clearErr() { if (els.err) { els.err.hidden = true; els.err.textContent = ''; } }
  function showErr(m) { if (els.err) { els.err.hidden = false; els.err.textContent = m; els.err.scrollIntoView({ block: 'nearest' }); } }

  /* ---------- add to cart ---------- */

  function validate() {
    if (!state.type) return 'Please choose an engraving type.';
    if (!state.fontLabel) return 'Please choose a font.';
    if (!state.front) return 'Please enter the front engraving text.';
    if (!state.confirmed) return 'Please confirm the engraving details are correct.';
    return null;
  }

  // Render a small snapshot (chosen disc image + text) for the order. Guarded:
  // resolves null on CORS taint / any error so the add never breaks.
  function snapshot(imgUrl, text) {
    return new Promise(function (resolve) {
      try {
        if (!imgUrl) { resolve(null); return; }
        var img = new Image(); img.crossOrigin = 'anonymous';
        img.onload = function () {
          try {
            var w = 320, h = Math.round(w * (img.naturalHeight / img.naturalWidth || 1));
            var c = document.createElement('canvas'); c.width = w; c.height = h;
            var ctx = c.getContext('2d');
            ctx.drawImage(img, 0, 0, w, h);
            var fam = (state.font || "'Jost'").split(',')[0];
            ctx.font = ((CFG.area.size / 100) * w) + 'px ' + fam;
            ctx.fillStyle = '#2a2a2a'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
            ctx.fillText(text || '', (CFG.area.cx / 100) * w, (CFG.area.cy / 100) * h, (CFG.area.width / 100) * w);
            resolve(c.toDataURL('image/jpeg', 0.6));
          } catch (e) { resolve(null); }
        };
        img.onerror = function () { resolve(null); };
        img.src = imgUrl;
      } catch (e) { resolve(null); }
    });
  }

  function addEngraved() {
    var frontImg = CFG.faces ? CFG.faces.front : P.image;
    var backImg = CFG.faces ? CFG.faces.back : P.image;
    return Promise.all([
      snapshot(frontImg, state.front),
      state.back ? snapshot(backImg, state.back) : Promise.resolve(null)
    ]).then(function (prev) {
      var props = {
        'Engraving?': 'Yes (£10.00)',
        'Engraving Type': state.type,
        'Text Front': state.front,
        'Font': state.fontLabel,
        'Review Your Engraving': 'I confirm the engraving details are correct'
      };
      if (state.back) props['Text Back'] = state.back;
      if (prev[0]) props['_Preview'] = prev[0];        // underscore = hidden in cart, kept on the order
      if (prev[1]) props['_Preview Back'] = prev[1];
      var key = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
      props['_engrave_key'] = key;
      var items = [{ id: P.variantId, quantity: 1, properties: props }];
      // linked £10 engraving fee line (the Engraving product)
      if (CFG.engraveVariantId) {
        items.push({ id: CFG.engraveVariantId, quantity: 1, properties: { _engrave_key: key, 'Engraving for': P.title } });
      }
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
    });
  }

  function interceptAdd() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest && ev.target.closest('.product-single__form button[name="add"], button.add-to-cart, .add-to-cart');
      if (!btn || btn.closest('.shopify-payment-button') || btn.closest('#FoxAddonRail')) return;
      if (!state.engrave) return;          // no engraving -> let the normal add run
      ev.preventDefault();
      ev.stopImmediatePropagation();
      var err = validate();
      if (err) { showErr(err); return; }
      btn.classList.add('btn--loading');
      addEngraved()
        .then(function () { if (window.jQuery) window.jQuery('body').trigger('added.ajaxProduct'); })
        .catch(function () { showErr('Something went wrong adding to cart. Please try again.'); })
        .then(function () { btn.classList.remove('btn--loading'); });
    }, true);
  }

  /* ---------- init ---------- */

  function init() {
    // hide the HulkApps engraving options (we own engraving now)
    document.querySelectorAll('[id^="hulkapps_custom_options_"]').forEach(function (h) { h.style.display = 'none'; });
    // inject our UI just before the add-to-cart button
    var btn = document.querySelector('.product-single__form button[name="add"], button.add-to-cart, .add-to-cart');
    if (!btn) return;
    var ui = buildUI();
    (btn.closest('.payment-buttons') || btn).parentNode.insertBefore(ui, (btn.closest('.payment-buttons') || btn));
    els.wrap = ui;
    els.panel = ui.querySelector('.fox-eng__panel');
    els.preview = ui.querySelector('.fox-eng__preview');
    els.img = ui.querySelector('.fox-eng__img');
    els.text = ui.querySelector('.fox-eng__text');
    els.types = ui.querySelector('.fox-eng__types');
    els.fonts = ui.querySelector('.fox-eng__fonts');
    els.fontsGroup = ui.querySelector('.fox-eng__fonts-group');
    els.front = ui.querySelector('.fox-eng__front');
    els.back = ui.querySelector('.fox-eng__back');
    els.confirm = ui.querySelector('.fox-eng__confirm-cb');
    els.err = ui.querySelector('.fox-eng__err');
    if (CFG.faces && CFG.faces.front) els.img.src = CFG.faces.front;
    else if (P.image) els.img.src = P.image;
    renderTypes();
    bind();
    interceptAdd();
  }

  function ready() {
    // hide HulkApps as soon as possible, then build once the form exists
    var tries = 0;
    (function wait() {
      tries++;
      var btn = document.querySelector('.product-single__form button[name="add"], button.add-to-cart, .add-to-cart');
      if (btn) { init(); }
      else if (tries < 100) { setTimeout(wait, 100); }
    })();
  }
  if (document.readyState !== 'loading') ready();
  else document.addEventListener('DOMContentLoaded', ready);
})();
